import { render, staticRenderFns } from "./BrAdminNotesPanel.vue?vue&type=template&id=e85ea408&scoped=true&"
import script from "./BrAdminNotesPanel.vue?vue&type=script&lang=js&"
export * from "./BrAdminNotesPanel.vue?vue&type=script&lang=js&"
import style0 from "./BrAdminNotesPanel.vue?vue&type=style&index=0&id=e85ea408&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ea408",
  null
  
)

export default component.exports